import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { PaginationMeta, TtsBatch, TtsEstimate, TtsGenerateResponse } from '@/types/tts'

interface ApiEnvelope<T> {
  success?: boolean
  message?: string
  data?: T
  meta?: PaginationMeta
}

export const ttsApi = {
  /** Смета стоимости озвучивания выбранных слов (без списания) */
  async estimate(wordIds: number[], force = false): Promise<TtsEstimate> {
    const response = await apiClient.post<ApiEnvelope<TtsEstimate>>(API_ENDPOINTS.TTS.ESTIMATE, {
      word_ids: wordIds,
      force,
    })
    return response.data.data as TtsEstimate
  },

  /** Запуск генерации: списывает стоимость и ставит джобы в очередь */
  async generate(wordIds: number[], force = false): Promise<TtsGenerateResponse> {
    const response = await apiClient.post<ApiEnvelope<TtsGenerateResponse>>(API_ENDPOINTS.TTS.GENERATE, {
      word_ids: wordIds,
      force,
    })
    return response.data.data as TtsGenerateResponse
  },

  /** Поллинг статуса батча */
  async getBatch(batchId: number): Promise<{ batch: TtsBatch; balance: string }> {
    const response = await apiClient.get<ApiEnvelope<{ batch: TtsBatch; balance: string }>>(
      API_ENDPOINTS.TTS.BATCH(batchId),
    )
    return response.data.data as { batch: TtsBatch; balance: string }
  },

  /** Список батчей текущего пользователя (страница задач озвучки) */
  async listBatches(page = 1, perPage = 15): Promise<{ data: TtsBatch[]; meta?: PaginationMeta }> {
    const response = await apiClient.get<ApiEnvelope<TtsBatch[]>>(API_ENDPOINTS.TTS.BATCHES, {
      params: { page, per_page: perPage },
    })
    return { data: response.data.data ?? [], meta: response.data.meta }
  },
}
